import {
  createRouter,
  createWebHistory,
  type RouteRecordRaw,
} from "vue-router";

// Route-level code splitting: each page chunk is loaded on demand.
// NOTE: there is intentionally no `/` route. The homepage is still the
// legacy public/index.html served by Express. If a `/` route existed here,
// clicking the brand/Home link inside the SPA would render an empty SPA
// home and "break" the marketing site for users. Add a `/` route here
// only when HomeView.vue is actually ready to replace the legacy page.
const NotFoundView = () => import("@/app/views/NotFoundView.vue");
const ProductsListView = () =>
  import("@/features/products").then((m) => m.ProductsListView);
const ProductDetailView = () =>
  import("@/features/products").then((m) => m.ProductDetailView);

const routes: RouteRecordRaw[] = [
  {
    path: "/products",
    name: "products",
    component: ProductsListView,
    meta: { title: "Products — RanaVolt" },
  },
  {
    path: "/products/:slug",
    name: "product-detail",
    component: ProductDetailView,
    props: true,
    meta: { title: "Product — RanaVolt" },
  },
  { path: "/:pathMatch(.*)*", name: "not-found", component: NotFoundView },
];

export const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(_to, _from, saved) {
    return saved || { top: 0 };
  },
});

router.afterEach((to) => {
  const title = typeof to.meta.title === "string" ? to.meta.title : "RanaVolt";
  document.title = title;
});
